/*******************************************************************************
 * Copyright (c) 2023 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   
 *  Amina Rais - Initial implementation
 *  Version: 1.0.0
 *
 *******************************************************************************/


import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Contactus from '../../../components/Views/public/Contactus' 

 
class ContactusPage extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);

  }
  render() {
    return (
      <> 
        <Contactus />
      </>
    )
  }
}

ContactusPage.propTypes = {
  classes: PropTypes.object.isRequired,
}

function mapStateToProps() {
  return {}
}

const styledContactusPage = ContactusPage
const connectedContactusPage = connect(mapStateToProps)(styledContactusPage)
export { connectedContactusPage as ContactusPage }
